import { ContractTranslate } from './contractTranslate.model';

const contractTranslatePTBR: ContractTranslate = {
  tab: {
    title: 'Contratos',
  },
  contractor: {
    section: {
      title: 'Contratado',
      description:
        'Cadastre os dados do contratado (você ou seu estúdio) que aparecerão nos contratos emitidos.',
      add: 'Novo contratado',
      empty: 'Nenhum contratado cadastrado',
    },
    personType: {
      label: 'Tipo de pessoa',
      PF: 'Pessoa física',
      PJ: 'Pessoa jurídica',
    },
    fields: {
      name: 'Nome / Razão social',
      cpf: 'CPF',
      cnpj: 'CNPJ',
      legalRepresentativeName: 'Nome do representante legal',
      legalRepresentativeDocument: 'CPF do representante legal',
      email: 'E-mail',
      phone: 'Telefone',
      instagram: 'Instagram',
    },
    modal: {
      titleCreate: 'Novo contratado',
      titleEdit: 'Editar contratado',
      save: 'Salvar',
      cancel: 'Cancelar',
    },
    actions: {
      edit: 'Editar contratado',
      delete: 'Excluir contratado',
    },
    delete: {
      title: 'Excluir contratado',
      text: 'Tem certeza que deseja excluir o contratado "{{name}}"?',
      secondaryText:
        'Os contratos já emitidos com este contratado não serão alterados.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    toast: {
      created: 'Contratado criado',
      updated: 'Contratado atualizado',
      deleted: 'Contratado excluído',
      error: {
        create: 'Não foi possível criar o contratado. Tente novamente',
        update: 'Não foi possível atualizar o contratado. Tente novamente',
        delete: 'Não foi possível excluir o contratado. Tente novamente',
      },
    },
    validation: {
      nameRequired: 'Informe o nome do contratado',
      nameMaxLength: 'O nome deve ter no máximo 100 caracteres',
      documentCpfInvalid: 'Informe um CPF válido com 11 dígitos',
      documentCnpjInvalid: 'Informe um CNPJ válido com 14 dígitos',
      legalRepresentativeNameMaxLength:
        'O nome do representante deve ter no máximo 100 caracteres',
      legalRepresentativeDocumentInvalid:
        'Informe um CPF válido com 11 dígitos',
      emailInvalid: 'Informe um e-mail válido',
      phoneMaxLength: 'O telefone deve ter no máximo 30 caracteres',
      instagramMaxLength: 'O Instagram deve ter no máximo 30 caracteres',
    },
  },
  legalInfo: {
    title: 'Dados contratuais',
    description:
      'Dados pessoais do cliente usados no preenchimento dos contratos.',
    fields: {
      cpf: 'CPF',
      rg: 'RG',
      profession: 'Profissão',
      maritalStatus: 'Estado civil',
      nationality: 'Nacionalidade',
    },
    save: 'Salvar dados contratuais',
    toast: {
      saved: 'Dados contratuais salvos',
      error: 'Não foi possível salvar os dados contratuais. Tente novamente',
    },
    validation: {
      cpfInvalid: 'Informe um CPF válido com 11 dígitos',
      rgMaxLength: 'O RG deve ter no máximo 20 caracteres',
      professionMaxLength: 'A profissão deve ter no máximo 100 caracteres',
      maritalStatusMaxLength: 'O estado civil deve ter no máximo 50 caracteres',
      nationalityMaxLength: 'A nacionalidade deve ter no máximo 50 caracteres',
    },
  },
  address: {
    title: 'Endereço',
    fields: {
      street: 'Rua',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Bairro',
      city: 'Cidade',
      state: 'Estado',
      zipCode: 'CEP',
    },
  },
  variableSource: {
    LEAD: 'Cliente',
    LEAD_LEGAL: 'Dados contratuais',
    CONTRACTOR: 'Contratado',
    SERVICE: 'Serviço',
    PAYMENT: 'Pagamento',
    ISSUANCE: 'Emissão',
    CUSTOM: 'Personalizado',
  },
  status: {
    DRAFT: 'Rascunho',
    ISSUED: 'Emitido',
    SIGNED: 'Assinado',
  },
  templates: {
    page: {
      title: 'Modelos de contrato',
      search: 'Buscar modelo',
      emptyState: 'Nenhum modelo de contrato cadastrado',
      emptyStateHint: 'Envie um arquivo .docx para criar seu primeiro modelo',
    },
    list: {
      variablesCount_one: '{{count}} variável',
      variablesCount_other: '{{count}} variáveis',
      active: 'Ativo',
      inactive: 'Inativo',
      more: 'Mais ações',
    },
    detail: {
      requirementsTitle: 'O que este modelo exige',
      requirementsDescription:
        'Prepare estes dados antes de emitir o contrato com este modelo.',
      requirementsEmpty: 'Este modelo não exige nenhum dado obrigatório',
      optionalTitle: 'Dados opcionais',
      noAnchorBadge: 'sem trecho vinculado no documento',
      missingAnchorsWarning:
        'As variáveis {{names}} não têm trecho vinculado e não serão preenchidas no documento.',
      variablesTitle: 'Variáveis do modelo',
      variablesEmpty: 'Este modelo não possui variáveis mapeadas',
      key: 'Chave',
      label: 'Rótulo',
      source: 'Origem',
      required: 'Obrigatória',
      requiredYes: 'Sim',
      requiredNo: 'Não',
      createdAt: 'Criado em',
      status: 'Status',
      close: 'Fechar detalhes',
    },
    actions: {
      detail: 'Ver detalhes',
      edit: 'Editar modelo',
      delete: 'Excluir modelo',
    },
    modal: {
      titleCreate: 'Novo modelo de contrato',
      titleEdit: 'Editar modelo de contrato',
      nameField: 'Nome do modelo',
      activeField: 'Modelo ativo',
      upload: {
        label: 'Arquivo do modelo (.docx)',
        hint: 'Apenas arquivos .docx de até 5MB',
        selectFile: 'Selecionar arquivo',
        changeFile: 'Trocar arquivo',
        uploading: 'Enviando arquivo…',
        reading: 'Lendo o documento…',
        analyzing: 'A IA está analisando o documento…',
        analyzingHint:
          'Identificando as variáveis do contrato. Isso pode levar até 20 segundos.',
        analysis: {
          title: 'Análise automática indisponível',
          emptyTitle: 'Não encontramos texto neste documento',
          manual:
            'A IA não conseguiu sugerir as variáveis agora. Siga com o mapeamento manual: selecione os trechos no texto para criar as variáveis.',
          fallback_one:
            'Encontramos {{count}} variável já escrita como marcador no documento. Confira e complete o mapeamento manualmente.',
          fallback_other:
            'Encontramos {{count}} variáveis já escritas como marcadores no documento. Confira e complete o mapeamento manualmente.',
          success_one:
            'A IA sugeriu {{count}} variável. Confira cada uma antes de salvar.',
          success_other:
            'A IA sugeriu {{count}} variáveis. Confira cada uma antes de salvar.',
          suggest: 'Sugerir variáveis com IA',
          reason: {
            NOT_CONFIGURED: 'A análise por IA está indisponível nesta conta.',
            TIMEOUT: 'A análise demorou demais para responder.',
            RATE_LIMITED:
              'Limite de uso da IA atingido. Tente de novo em alguns minutos.',
            UNAVAILABLE: 'O serviço de IA está instável no momento.',
            DOCUMENT_TOO_LONG:
              'Este contrato é longo demais para a análise automática.',
            INVALID_OUTPUT:
              'A IA devolveu uma resposta que não conseguimos aproveitar.',
            DOCUMENT_EMPTY:
              'Não há texto selecionável neste .docx. Ele pode ser um documento escaneado (imagem) ou ter o conteúdo só em cabeçalho e rodapé. Envie um arquivo com o texto no corpo.',
          },
        },
      },
      back: 'Voltar',
      next: 'Continuar',
      save: 'Salvar modelo',
      cancel: 'Cancelar',
    },
    variables: {
      title: 'Variáveis',
      description:
        'Revise as variáveis e onde elas aparecem no documento. Selecione um trecho do texto para marcar uma nova ocorrência.',
      empty: 'Nenhuma variável mapeada',
      add: 'Adicionar variável',
      keyField: 'Chave',
      labelField: 'Rótulo',
      sourceField: 'Origem',
      requiredField: 'Obrigatória',
      remove: 'Remover variável',
      anchorsCount_one: '{{count}} ocorrência marcada',
      anchorsCount_other: '{{count}} ocorrências marcadas',
      notPositioned: 'Não posicionada no documento',
      removeAnchor: 'Remover ocorrência',
      locate: 'Ver no documento',
      keyHint: 'A chave é gerada a partir do rótulo e usada como marcador.',
      validation: {
        keyRequired: 'Informe a chave da variável',
        keyDuplicated: 'Chave duplicada',
        labelRequired: 'Informe o rótulo da variável',
      },
    },
    editor: {
      title: 'Mapeie as variáveis no documento',
      instruction:
        'Selecione um trecho do texto (ex.: o nome do cliente) e transforme em uma variável.',
      simplifiedNotice: 'Visualização em texto simplificado',
      documentTab: 'Documento',
      variablesTab: 'Variáveis',
      loadingDocument: 'Carregando documento…',
      emptyDocument: 'Nenhum texto disponível para este modelo.',
      emptyDocumentHint:
        'Se o arquivo for digitalizado (imagem) ou tiver o conteúdo só em cabeçalho e rodapé, envie um .docx com o texto no corpo.',
      selectionInvalid: 'Selecione um trecho dentro de um único parágrafo.',
      selectionTooShort:
        'Selecione um trecho com ao menos 2 caracteres e uma letra ou número.',
      previewToggle: 'Pré-visualizar preenchido',
      previewValues: {
        LEAD: 'Maria da Silva',
        LEAD_LEGAL: '123.456.789-00',
        CONTRACTOR: 'Estúdio Exemplo Ltda.',
        SERVICE: 'Ensaio fotográfico — Pacote Ouro',
        PAYMENT: 'R$ 2.500,00 em 3x',
        ISSUANCE: 'São Paulo, 21 de julho de 2026',
      },
      popover: {
        title: 'Marcar variável',
        context: 'Trecho selecionado',
        linkExisting: 'Vincular a uma variável existente',
        createNew: 'Criar nova variável',
        existingField: 'Variável',
        labelField: 'Rótulo',
        sourceField: 'Origem',
        requiredField: 'Obrigatória',
        keyField: 'Chave (marcador)',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        labelRequired: 'Informe o rótulo da variável',
        noVariables: 'Nenhuma variável criada ainda',
        reviewTitle: 'Revisar trecho',
        linkedTo: 'Vinculado a: {{label}}',
        removeAnchor: 'Remover trecho',
        changeVariable: 'Trocar variável',
        applyToOthers_one: 'Aplicar à outra {{count}} ocorrência',
        applyToOthers_other: 'Aplicar às outras {{count}} ocorrências',
      },
    },
    confirmMissingAnchors: {
      title: 'Variáveis sem trecho vinculado',
      text: 'Algumas variáveis obrigatórias não têm trecho vinculado no documento.',
      secondaryText:
        'Elas não serão preenchidas nos contratos emitidos. Deseja salvar mesmo assim?',
      confirm: 'Salvar mesmo assim',
      cancel: 'Revisar variáveis',
    },
    validation: {
      nameRequired: 'Informe o nome do modelo',
      nameMaxLength: 'O nome deve ter no máximo 100 caracteres',
      fileRequired: 'Envie o arquivo .docx do modelo',
      noAnchors:
        'Marque ao menos uma ocorrência no documento antes de salvar o modelo.',
    },
    delete: {
      title: 'Excluir modelo',
      text: 'Tem certeza que deseja excluir o modelo "{{name}}"?',
      secondaryText:
        'Os contratos já emitidos com este modelo não serão alterados.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    toast: {
      created: 'Modelo de contrato criado',
      updated: 'Modelo de contrato atualizado',
      deleted: 'Modelo de contrato excluído',
      error: {
        create: 'Não foi possível criar o modelo. Tente novamente',
        update: 'Não foi possível atualizar o modelo. Tente novamente',
        delete: 'Não foi possível excluir o modelo. Tente novamente',
      },
    },
    errors: {
      invalidFile: 'Apenas arquivos .docx são aceitos',
      fileTooLarge: 'O arquivo deve ter no máximo 5MB',
      uploadFailed: 'Não foi possível enviar o arquivo. Tente novamente',
      unauthorized: 'Você não tem permissão pra acessar esta página.',
      analyzeUnreachable:
        'Não foi possível falar com o servidor para sugerir as variáveis. Você pode mapeá-las manualmente.',
      paragraphsUnreachable:
        'Não foi possível ler o documento. Verifique sua conexão e envie o arquivo de novo.',
    },
  },
  leadContracts: {
    title: 'Contratos',
    description: 'Contratos emitidos para este cliente.',
    issueButton: 'Emitir contrato',
    empty: 'Nenhum contrato emitido para este cliente',
    issuedAt: 'Emitido em {{date}}',
    fallbackTemplateName: 'Contrato',
    uploadingSigned: 'Enviando contrato assinado…',
    signedUpload: {
      placeholder: 'Arraste o PDF assinado aqui ou clique para selecionar',
      hint: 'Apenas arquivos .pdf de até 10 MB',
    },
    actions: {
      downloadDocx: 'Baixar DOCX',
      downloadSigned: 'Baixar assinado',
      uploadSigned: 'Enviar assinado',
      delete: 'Excluir contrato',
      more: 'Mais ações',
    },
    delete: {
      title: 'Excluir contrato',
      text: 'Tem certeza que deseja excluir este contrato?',
      secondaryText: 'Os arquivos gerados deixarão de ficar disponíveis.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
    toast: {
      deleted: 'Contrato excluído',
      deleteError: 'Não foi possível excluir o contrato. Tente novamente',
      downloadError: 'Não foi possível baixar o arquivo. Tente novamente',
      signedUploaded: 'Contrato assinado enviado',
      signedUploadError:
        'Não foi possível enviar o contrato assinado. Tente novamente',
    },
    errors: {
      invalidSignedFile: 'Apenas arquivos PDF são aceitos',
      signedFileTooLarge: 'O arquivo deve ter no máximo 10MB',
    },
  },
  issue: {
    modal: {
      title: 'Emitir contrato',
      templateField: 'Modelo de contrato',
      contractorField: 'Contratado',
      issuanceCityField: 'Cidade de emissão',
      saleField: 'Venda',
      fillLegalTitle: 'Preencher dados do cliente',
      fillLegalHint:
        'Estes campos faltam para este modelo. Ao salvar, eles ficam no cadastro do cliente e serão reaproveitados nos próximos contratos.',
      fillLegalSave: 'Salvar e revisar',
      missingAddressHint:
        'O endereço do cliente está incompleto. Preencha na aba Contratos do lead, em Dados do cliente.',
      saleFieldLatest: 'Venda mais recente',
      customValuesTitle: 'Campos do contrato',
      noActiveTemplates:
        'Nenhum modelo ativo disponível. Cadastre um modelo na página de Contratos.',
      noContractors:
        'Nenhum contratado cadastrado. Cadastre um contratado nas Configurações.',
      next: 'Revisar dados',
      back: 'Voltar',
      confirm: 'Emitir contrato',
      cancel: 'Cancelar',
      issuing: 'Gerando documento…',
      issuingHint: 'Isso pode levar alguns segundos. Não feche esta janela.',
      previewTitle: 'Revisão dos dados',
      previewDescription:
        'Confira os valores que serão usados no contrato antes de emitir.',
      missingTitle: 'Dados pendentes',
      missingAnchorsWarning:
        'As variáveis {{names}} não têm trecho vinculado e não serão preenchidas no contrato.',
      emptyValue: '—',
    },
    missingHint: {
      LEAD: 'Preencha no cadastro do cliente',
      LEAD_LEGAL: 'Preencha nos dados contratuais do cliente',
      CONTRACTOR: 'Preencha no cadastro do contratado',
      SERVICE: 'Preencha nos campos do contrato',
      PAYMENT: 'Preencha nos campos do contrato',
      ISSUANCE: 'Informe a cidade de emissão',
      CUSTOM: 'Preencha nos campos do contrato',
    },
    validation: {
      templateRequired: 'Selecione um modelo de contrato',
      contractorRequired: 'Selecione um contratado',
    },
    toast: {
      legalInfoSaved: 'Dados do cliente salvos',
      legalInfoError: 'Nao foi possivel salvar os dados do cliente',
      issued: 'Contrato emitido',
      pdfFailed:
        'Contrato emitido, mas a geração do PDF falhou. O DOCX está disponível para download.',
      error: 'Não foi possível emitir o contrato. Tente novamente',
      previewError:
        'Não foi possível carregar a revisão dos dados. Tente novamente',
    },
  },
  signature: {
    loading: 'Carregando assinatura…',
    expiresAt: 'Expira em {{date}}',
    acceptedAt: 'Assinado em {{date}}',
    status: {
      PENDING: 'Aguardando assinatura',
      ACCEPTED: 'Assinado',
      EXPIRED: 'Expirado',
      CANCELED: 'Cancelado',
    },
    actions: {
      send: 'Enviar para assinatura',
      copyLink: 'Copiar link',
      cancel: 'Cancelar solicitação',
    },
    toast: {
      linkCopied: 'Link copiado',
      linkCopyError: 'Não foi possível copiar o link',
      canceled: 'Solicitação de assinatura cancelada',
      cancelError: 'Não foi possível cancelar a solicitação. Tente novamente',
    },
    cancel: {
      title: 'Cancelar solicitação de assinatura',
      text: 'Tem certeza que deseja cancelar esta solicitação de assinatura?',
      secondaryText: 'O link enviado ao signatário deixará de funcionar.',
      confirm: 'Cancelar solicitação',
      cancel: 'Voltar',
    },
    modal: {
      title: 'Enviar para assinatura',
      description:
        'Gere um link de assinatura eletrônica para enviar ao signatário.',
      submit: 'Gerar link',
      cancel: 'Cancelar',
      fields: {
        signerName: 'Nome do signatário',
        signerEmail: 'E-mail do signatário (opcional)',
        signerDocument: 'CPF do signatário (opcional)',
      },
      validation: {
        signerNameRequired: 'Informe o nome do signatário',
        signerNameMaxLength: 'O nome deve ter no máximo 256 caracteres',
        signerEmailInvalid: 'Informe um e-mail válido',
        signerDocumentInvalid: 'Informe um documento válido',
      },
      toast: {
        created: 'Link de assinatura gerado',
        createError:
          'Não foi possível gerar o link de assinatura. Tente novamente',
        linkCopied: 'Link copiado',
        linkCopyError: 'Não foi possível copiar o link',
      },
      success: {
        title: 'Link de assinatura gerado',
        hint: 'Copie o link abaixo e envie ao signatário.',
        copy: 'Copiar link',
        validity: 'O link é válido por 30 dias.',
        done: 'Concluir',
      },
    },
  },
};

export default contractTranslatePTBR;
